import createPromise from "nq/src/createPromise";
import BaseListPresenter from "../../base/BaseListPresenter";
import { dialog } from "../../nq-component";
import ConfirmDialog from "../../base/ProgressDialog";

class SellerDocumentListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
  }

  init() {
    this.limit = 10;
    this.where = { status: "Pending" };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.sort = { createdAt: -1 };
    this.reset();
  }

  componentDidUpdate(prevProps) {
    const query = this.view.getQuery();
    if (query?.where && prevProps?.query?.where !== query?.where) {
      this.reset();
      this.where = JSON.parse(query.where);
      this.getObjects();
    }
  }

  // show success dialog
  showSuccess(message, title) {
    const options = {
      title: title || "Success",
      message: message,
      icon: "bi bi-check-circle",
      type: "success",
      positiveButton: "OKAY",
      negativeButton: false,
    };
    return this.showDialog(options);
  }

  // the generic popup dialog
  showDialog({ title, message, icon, type, ...options }) {
    const promise = createPromise();
    dialog.fire({
      html: (
        <ConfirmDialog
          icon={icon}
          title={title}
          message={message}
          type={type}
        />
      ),
      onPositiveClick: () => {
        promise.resolve();
      },
      onNegativeClick: () => {
        promise.reject();
      },
      ...options,
    });
    return promise;
  }

  async handleApplication(index, status) {
    const object = this.objects[index];
    object.status = status;
    const collection = this.view.getCollectionName();

    try {
      const data = await this.upsertUseCase.execute(collection, object);
      if (data.status === object.status) {
        this.objects[index] = object;
        this.view.setObjects(this.objects);
      }
      // change the roles of the user
      // const user = object.user
      // user.roles = [{id: 'c0fd9661-f5eb-4a0b-a9e0-ceb3d5019fc0'}]
      // if (object.isBroker === true) {
      //     user.isBroker = true
      // }
      // await this.upsertUseCase.execute('users', user)
      await this.view.showSuccess("Application " + status + " successfully!");
      this.reset();
      this.getObjects();
    } catch (error) {
      this.view.showError(error);
    }
  }
}

export default SellerDocumentListPresenter;
